import React, { useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

// Default marker icons fix for webpack
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
});

const saffronIcon = L.divIcon({
  className: "tti-marker",
  iconSize: [28, 28],
  iconAnchor: [14, 28],
  html: `<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="#F26722" stroke="#fff" stroke-width="2"><path d="M12 2C8 2 4 5.1 4 10c0 5 8 12 8 12s8-7 8-12c0-4.9-4-8-8-8z"/><circle cx="12" cy="10" r="3" fill="#fff"/></svg>`,
});

export default function SketchMap({ coords = [], height = 360 }) {
  const containerRef = useRef(null);
  const mapRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current || !coords || coords.length === 0) return;
    if (mapRef.current) {
      mapRef.current.remove();
      mapRef.current = null;
    }
    const map = L.map(containerRef.current, {
      scrollWheelZoom: false,
      zoomControl: true,
      attributionControl: false,
    });
    mapRef.current = map;

    // CartoDB Voyager style — clean, warm
    L.tileLayer("https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png", {
      subdomains: "abcd",
      maxZoom: 19,
    }).addTo(map);

    const latlngs = coords.map((c) => [c.lat, c.lng]);

    // Polyline connecting stops
    if (latlngs.length > 1) {
      L.polyline(latlngs, {
        color: "#8B0000",
        weight: 3,
        opacity: 0.85,
        dashArray: "6 8",
      }).addTo(map);
    }

    // Markers
    coords.forEach((c, idx) => {
      L.marker([c.lat, c.lng], { icon: saffronIcon })
        .addTo(map)
        .bindTooltip(`<strong>Day ${idx + 1}</strong> · ${c.label}`, {
          permanent: false,
          direction: "top",
          offset: [0, -22],
          className: "tti-tooltip",
        });
    });

    // Fit bounds
    if (latlngs.length > 1) {
      map.fitBounds(latlngs, { padding: [40, 40] });
    } else {
      map.setView(latlngs[0], 7);
    }

    return () => {
      map.remove();
      mapRef.current = null;
    };
  }, [coords]);

  if (!coords || coords.length === 0) return null;

  return (
    <div
      ref={containerRef}
      data-testid="sketch-map"
      className="w-full rounded-sm overflow-hidden border border-cream-200 bg-cream-100"
      style={{ height }}
    />
  );
}
